<template>
   <ul class="nav nav-pills nav-stacked">
       <router-link tag="li" v-for="route in routes" :key="route.routeName" :to="{ name: route.routeName}">
           <a>{{route.label}}</a>
       </router-link>
    </ul>
</template>

<script>
export default {
  name: "TheSidebar",
  props: ["routes"]
};
</script>

<style scoped>
.router-link-active {
  background: #cc0000;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheSidebar.vue